/* Studding remains available to staff in Shopify, never as an online add-on. */
(function () {
  'use strict';
  const ids = new Set(['52202908254505', '50790925959465', '51635589906729',
    ...(window.tntStaffOnlyStuddingVariants || []).map(String)]);
  const message = 'Studding is available on local orders only. Contact us before ordering: 709-714-1901 or info@truenorthtires.ca.';
  const nativeFetch = window.fetch.bind(window);
  const isStudding = item => ids.has(String(item.variant_id || item.id || '')) ||
    /^add-studding(?:-|$)/i.test(item.handle || '') ||
    /Studding\s*[–-]\s*Contact Us/i.test(item.product_title || item.title || '');
  function blockedBody(body) {
    try {
      const data = typeof body === 'string' ? JSON.parse(body) : body;
      if (data && typeof data.get === 'function') {
        if (ids.has(String(data.get('id')))) return true;
        for (const [key, value] of data.entries()) {
          if (/^items\[\d+\]\[id\]$/.test(key) && ids.has(String(value))) return true;
        }
        return false;
      }
      return !!data && (ids.has(String(data.id || '')) ||
        (data.items || []).some(item => ids.has(String(item.id))));
    } catch (_) {
      const data = new URLSearchParams(body);
      return ids.has(String(data.get('id'))) ||
        Array.from(data.entries()).some(([key, value]) => /^items\[\d+\]\[id\]$/.test(key) && ids.has(String(value)));
    }
  }
  window.fetch = async function (input, init) {
    const url = new URL(typeof input === 'string' ? input : input.url || String(input), location.origin);
    if (url.origin === location.origin && /\/cart\/add(?:\.js|\.json)?\/?$/.test(url.pathname)) {
      const body = init && init.body !== undefined ? init.body :
        input instanceof Request ? await input.clone().text() : null;
      if (blockedBody(body)) return new Response(JSON.stringify({ status: 422, message, description: message }),
        { status: 422, headers: { 'Content-Type': 'application/json' } });
    }
    return nativeFetch(input, init);
  };
  function removeControls(root) {
    root.querySelectorAll('[data-tnt-addon-variant]').forEach(control => {
      if (!ids.has(String(control.dataset.tntAddonVariant))) return;
      control.checked = false;
      (control.closest('label') || control).remove();
    });
    root.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      if (!ids.has(String(new FormData(form).get('id')))) return;
      form.querySelectorAll('[type="submit"],.shopify-payment-button').forEach(node => node.remove());
    });
  }
  let cleaning = null;
  let removed = false;
  async function cleanCart() {
    if (cleaning) return cleaning;
    cleaning = (async () => {
      const base = (window.Shopify && window.Shopify.routes.root) || '/';
      const response = await nativeFetch(base + 'cart.js', { cache: 'no-store' });
      if (!response.ok) throw new Error('Unable to verify cart');
      const cart = await response.json();
      const updates = {};
      (cart.items || []).filter(isStudding).forEach(item => { updates[item.key] = 0; });
      if (!Object.keys(updates).length) return;
      const update = await nativeFetch(base + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates })
      });
      if (!update.ok) throw new Error('Unable to remove online studding');
      const updatedCart = await update.json();
      if ((updatedCart.items || []).some(isStudding)) throw new Error('Studding remains in cart');
      removed = true;
      try { sessionStorage.setItem('tnt-studding-removed', 'true'); } catch (_) {}
    })().finally(() => { cleaning = null; });
    return cleaning;
  }
  function showNotice() {
    if (!document.getElementById('tnt-studding-cart-notice')) {
      const notice = document.createElement('p');
      notice.id = 'tnt-studding-cart-notice';
      notice.setAttribute('role', 'status');
      notice.textContent = message;
      (document.querySelector('main') || document.body).prepend(notice);
    }
  }
  let proceeding = false;
  async function guardCheckout(event) {
    if (proceeding) return;
    const target = event.type === 'submit' ? event.submitter :
      event.target.closest('[name="checkout"],a[href*="/checkout"]');
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    try {
      await cleanCart();
      if (removed) { showNotice(); location.href = ((window.Shopify && window.Shopify.routes.root) || '/') + 'cart'; return; }
      proceeding = true;
      if (target.tagName === 'A') location.href = target.href;
      else if (target.form) target.form.requestSubmit(target);
      else target.click();
    } catch (_) { showNotice(); }
  }
  function start() {
    removeControls(document);
    new MutationObserver(() => removeControls(document)).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('submit', event => {
      const form = event.target;
      if (form.matches('form[action*="/cart/add"]') && blockedBody(new FormData(form))) {
        event.preventDefault(); event.stopImmediatePropagation(); showNotice();
      }
    }, true);
    document.addEventListener('click', guardCheckout, true);
    document.addEventListener('submit', guardCheckout, true);
    try {
      if (sessionStorage.getItem('tnt-studding-removed')) {
        sessionStorage.removeItem('tnt-studding-removed'); showNotice();
      }
    } catch (_) {}
    document.documentElement.classList.add('tnt-studding-cart-checking');
    cleanCart().then(() => {
      if (removed && /\/cart\/?$/.test(location.pathname)) location.reload();
      else document.documentElement.classList.remove('tnt-studding-cart-checking');
    }).catch(() => { /* Checkout repeats verification and remains blocked on failure. */ });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
